import { render } from "./FlowSection.vue?vue&type=template&id=201e7c68&scoped=true"
import script from "./FlowSection.vue?vue&type=script&lang=js"
export * from "./FlowSection.vue?vue&type=script&lang=js"

import "./FlowSection.vue?vue&type=style&index=0&id=201e7c68&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201e7c68"]])

export default __exports__